import { environment } from '@environment';
import React from 'react';
import styles from './investor-pdf-box.module.scss';
import { IGetInvestorsLinksResponse } from '@anghami/neogateway/dist/endpoints/getInvestorsLinks';

interface IProps {
	title: string;
	data: IGetInvestorsLinksResponse['links'];
}

export const PDFBox = ({ title, data }: IProps) => (
	<div className={styles.box}>
		<h2 className={styles.title}>{title}</h2>
		<div className={styles.boxItemsContainer}>
			{data.map((item) => {
				return (
					<a
						key={item.title + item.url}
						href={item.url}
						target="_blank"
						className={styles.boxItem}
						rel="noreferrer"
					>
						<div>
							<img src={environment.images_cdn_url + '/investors/pdf.svg'} alt="pdf" />
							<span>{item.title}</span>
						</div>
						<img
							className={styles.arrow}
							src={environment.images_cdn_url + '/investors/arrow.svg'}
							alt="arrow"
						/>
					</a>
				);
			})}
		</div>
	</div>
);
